export class AreaSupervisionModel {
  public system: any[] = [];
  public notes: string;
}
